"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var styles_1 = __importDefault(require("./styles"));
var HeaderCell = function (_a) {
    var column = _a.column;
    var sort = !!column.sort
        ? react_1.default.createElement(Icon_1.default, { className: "sort " + column.sort, icon: column.sort === 'ASC' ? 'up' : 'down' })
        : null;
    if (column.isHidden)
        return null;
    return (react_1.default.createElement(styles_1.default, { style: column.style, onClick: column.onClick },
        react_1.default.createElement("span", { className: "label" }, column.label),
        sort));
};
exports.default = HeaderCell;
//# sourceMappingURL=index.js.map